import { useMutation } from '@tanstack/react-query'
import { completeProgress } from '../api/onboardingProgressAPI'

export function useCompleteProgress() {
  return useMutation({
    mutationFn: ({
      token,
      orgUuid,
    }: {
      token: string
      orgUuid: string
    }) => completeProgress(token, orgUuid),
  })
}
